import * as React from 'react';
import toast from 'cogo-toast';
import { Redirect } from 'react-router-dom';
import { Page, Grid, Form, Button, Alert } from 'tabler-react';

import Request from '../../shared/request';
import PageComponent from '../PageComponent';
import store from '../../shared/store';

class EmailConfirm extends PageComponent {
  state = {
    loading: false,
    sending: false,
    passcode: null,
    countdown: 0,
    email: '',
  };

  confirm = async event => {
    event.preventDefault();
    if (!this.state.passcode) {
      toast.warn('请输入验证码');
      return;
    }
    if (this.state.loading) return;
    this.setState({ loading: true });
    const res = await Request.call('confirmUserEmail', {
      passcode: this.state.passcode,
      uid: store.user.uid,
    });
    this.setState({ loading: false });
    if (res) {
      toast.success('确认成功');
      store.updateUser();
    }
  };

  sendCode = async () =>  {
    if (this.state.sending) {
      toast.warn('验证码正在发送中')
      return
    }
    if (this.state.email !== store.user.email) {
      toast.warn('输入邮箱与登录邮箱不匹配');
      return;
    }
    this.setState({ sending: true });
    const passcode = await Request.call('sendPasscode', {
      type: 'email',
      from: 'CONFIRM_EMAIL',
      email: store.user.email,
    });
    if (passcode) {
      this.createTimer();
      toast.success('发送成功');
    }
    this.setState({ sending: false });
  }

  createTimer = () => {
    if (!this.state.countdown) {
      this.setState({ countdown: 60 });
      this.timer = setInterval(() => {
        if (this.state.countdown <= 0) {
          clearInterval(this.timer);
        }
        this.setState(prev => ({ countdown: prev.countdown - 1 }));
      }, 1000);
    }
  }

  render() {
    if (store.user.status === 'OK') return <Redirect to="/dashboard" />;

    return (
      <Grid.Row className="malus-setting">
        <Grid.Col xl={6} offsetXl={3} lg={6} offsetLg={3}>
          <Page.Card title="确认邮箱">
            <Alert type="success">
              确认邮箱即可获得VIP试用，请到邮箱查收验证码，如果没有请查看Spam/垃圾箱。
            </Alert>

              <Form.InputGroup
                append={
                  <Button
                    RootComponent="button"
                    type="button"
                    disabled={this.state.sending || this.state.countdown}
                    onClick={this.sendCode}>
                    {this.state.countdown ? `过${this.state.countdown}秒重发` : '发送验证码'}
                  </Button>
                }>
                <Form.Input
                  onChange={e => this.setState({ email: e.target.value })}
                  placeholder="请输入帐号邮箱"
                  autoComplete="off"
                />
              </Form.InputGroup>
              <div style={{'margin-top': '10px'}}>
                <Form.Input
                  onChange={e => this.setState({ passcode: e.target.value })}
                  placeholder="请输入邮箱验证码"
                  autoComplete="off"
                />
                </div>
              <Button
                onClick={this.confirm}
                className="malus-setting-btn"
                disabled={this.state.loading}
                loading={this.state.loading}
                color="primary">
                确认
              </Button>
          </Page.Card>
        </Grid.Col>
      </Grid.Row>
    );
  }
}

export default EmailConfirm;
